module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/ABOUT_03_ecocons_03.png";